<div *ngIf="vo$ | async; let vo" class="exposition-endpoint-metadata-form">
	<div *ngIf="!vo.isInViewMode">
		<form
			[formGroup]="endpointMetadataForm.form"
			class="exposition-endpoint-metadata-form__config">
			<mat-form-field [appearance]="Appearance">
				<mat-label i18n="@@exposition.metadata.form.accessPoint">
					access point
				</mat-label>
				<input
					type="text"
					id="{{ cmpId + '-access-point-input' }}"
					matInput
					[formControlName]="EndpointMetadataFormControls.AccessPoint" />
				<mat-hint [align]="'end'">
					{{
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.AccessPoint)?.value?.length || 0
					}}/{{Configuration.maxLengthAccessPoint}}
				</mat-hint>
				<mat-error
					*ngIf="
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.AccessPoint)
							?.hasError(ValidationErrorKeys.Pattern) ||
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.AccessPoint)
							?.hasError(ValidationErrorKeys.Maxlength) ||
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.AccessPoint)
							?.hasError(ValidationErrorKeys.Minlength)
					"
					i18n="@@exposition.metadata.form.accessPoint.authorizedCharacters">
					forbidden-characters-present
				</mat-error>
				<mat-error
					*ngIf="
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.AccessPoint)
							?.hasError(ValidationErrorKeys.Required)
					"
					i18n="@@general.form.errors.required">
					required
				</mat-error>
				<mat-error
					*ngIf="
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.AccessPoint)
							?.hasError(ValidationErrorKeys.UnavailableToUse)
					"
					i18n="@@exposition.metadata.form.accessPoint.error.duplicate">
					duplicates
				</mat-error>
			</mat-form-field>

			<mat-form-field [appearance]="Appearance">
				<mat-label i18n="@@exposition.metadata.form.title">title</mat-label>
				<input
					type="text"
					id="{{ cmpId + '-title-input' }}"
					matInput
					[formControlName]="EndpointMetadataFormControls.Title" />
				<mat-hint [align]="'end'">
					{{
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.Title)?.value?.length || 0
					}}/{{Configuration.maxLengthLabel}}
				</mat-hint>
				<mat-error
					*ngIf="
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.Title)
							?.hasError(ValidationErrorKeys.Maxlength)
					"
					i18n="@@general.form.errors.maxlength">
					max length
				</mat-error>
				<mat-error
					*ngIf="
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.Title)
							?.hasError(ValidationErrorKeys.Required)
					"
					i18n="@@general.form.errors.required">
					required
				</mat-error>
			</mat-form-field>

			<mat-form-field [appearance]="Appearance">
				<mat-label i18n="@@exposition.metadata.form.details">details</mat-label>
				<textarea
					[rows]="4"
					type="text"
					id="{{ cmpId + '-details-input' }}"
					matInput
					[formControlName]="EndpointMetadataFormControls.Details"></textarea>
				<mat-hint [align]="'end'">
					{{
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.Details)?.value?.length || 0
					}}/{{Configuration.maxLengthDescription}}
				</mat-hint>
				<mat-error
					*ngIf="
						endpointMetadataForm.form
							.get(EndpointMetadataFormControls.Details)
							?.hasError(ValidationErrorKeys.Maxlength)
					"
					i18n="@@general.form.errors.maxlength">
					max length
				</mat-error>
			</mat-form-field>

			<div class="form-field-group">
				<mat-label i18n="@@exposition.synthesisType">synthesis-type</mat-label>
				<div class="form-field">
					<mat-radio-group class="synthesis-type-group" [formControlName]="EndpointMetadataFormControls.SynthesisType">
						<mat-radio-button [value]="true"
															i18n="@@exposition.synthesisType.additive">add</mat-radio-button>
						<mat-radio-button [value]="false"
															i18n="@@exposition.synthesisType.restrictive">restrict</mat-radio-button>
					</mat-radio-group>
					<span *ngIf="endpointMetadataForm.form.value[EndpointMetadataFormControls.SynthesisType]"
								class="synthesis-type-hint"
								i18n="@@exposition.synthesisType.additive.hint">additive-hint</span>
					<span *ngIf="!endpointMetadataForm.form.value[EndpointMetadataFormControls.SynthesisType]"
								class="synthesis-type-hint"
								i18n="@@exposition.synthesisType.restrictive.hint">restrictive-hint</span>
				</div>
			</div>
		</form>

		<app-tag-configurator
			[configuredTags]="vo.expositionMetadata.keywords | toArray"
			(hasChangedValue)="hasKeyWordsChanged($event)"
			configMode="ActiveEdit"
			displayMode="keywords"></app-tag-configurator>
	</div>

	<div
		*ngIf="vo.isInViewMode"
		class="exposition-endpoint-metadata-form__view-mode">
		<div>
			<span
				i18n="@@exposition.metadata.form.accessPoint"
				id="{{ cmpId + '-accesslabel-input' }}"
				class="exposition-endpoint-metadata-form__title">
				access point
			</span>
			<span id="{{ cmpId + '-accesslabel-input-value' }}"> {{ vo.expositionMetadata.accessPoint }} </span>
		</div>
		<div>
			<span
				i18n="@@exposition.metadata.form.title"
				class="exposition-endpoint-metadata-form__title">
				title
			</span>
			<span
				[matTooltip]="vo.expositionMetadata.title"
				[matTooltipDisabled]="vo.expositionMetadata.title.length <= Configuration.maxLengthExpoEndpointMetadataTitleDisplay"
				matTooltipPosition="right">
				{{ vo.expositionMetadata.title | truncate: Configuration.maxLengthExpoEndpointMetadataTitleDisplay : 1 : 'end' }}
			</span>
		</div>
		<div>
			<span
				i18n="@@exposition.metadata.form.details"
				class="exposition-endpoint-metadata-form__title">
				description
			</span>
			<span
				class="view-details"
				[matTooltip]="vo.expositionMetadata.details"
				[matTooltipDisabled]="vo.expositionMetadata.details.length <= Configuration.maxLengthExpoEndpointMetadataDetailsDisplay"
				matTooltipPosition="right">
				{{ vo.expositionMetadata.details | truncate: Configuration.maxLengthExpoEndpointMetadataDetailsDisplay : 1 : 'end' }}
			</span>
		</div>
		<div>
			<span
				i18n="@@exposition.synthesisType"
				class="exposition-endpoint-metadata-form__title">
				synthesis-type
			</span>
			{{ vo.expositionMetadata.synthesisType }}
		</div>
		<div>
			<span
				i18n="@@exposition.metadata.form.keywords"
				class="exposition-endpoint-metadata-form__title">
				title
			</span>
			<app-tag-configurator
				[configuredTags]="vo.expositionMetadata.keywords | toArray"
				configMode="View"
				displayMode="keywords"></app-tag-configurator>
		</div>
	</div>
</div>
